import React from "react";
import ReactECharts from "echarts-for-react";
import _ from "lodash";
import Spinner from "../../../../../../utils/Spinner";

const TableQualityGraph = (props) => {
  const tablequalitydatafetch = props.tablequalitygraph;
  const fetching = props.fetching;
  let metricValue = _.map(tablequalitydatafetch, "metricValue");
  let updatedAt = _.map(tablequalitydatafetch, "updatedAt");

  const option = {
    color: "#00786B",
    tooltip: [
      {
        formatter: function (params) {
          return `Updated At : ${params.name}
          <br/> Metric Value : ${params.value} % `;
        },
        backgroundColor: "#323437",
        textStyle: {
          color: "white",
        },
      },
    ],
    grid: {
      left: "17%",
    },
    xAxis: {
      type: "category",
      name: "DATE",
      nameLocation: "middle",
      nameTextStyle: {
        color: "black",
        fontSize: 12,
        fontStyle: "Bold",
      },
      nameGap: "40",
      data: updatedAt,
    },

    title: {
      text: "",
      left: "3%",
      top: 0,
      textStyle: {
        color: "black",
      },
    },
    yAxis: {
      type: "value",
      position: "left",
      name: "QUALITY (%)",
      nameLocation: "middle",
      nameGap: "52",
      nameTextStyle: {
        color: "black",
        fontSize: 12,
        fontStyle: "Bold",
      },
      axisLabel: {
        formatter: "{value} %",
      },
    },
    series: [
      {
        data: metricValue,
        type: "line",
      },
    ],
  };

  return (
    <React.Fragment>
      {fetching ? (
        <div className="justify-content-md-center">
          {" "}
          <Spinner />
        </div>
      ) : (
        <div className="regular_border">
              <div className="utilization-usercount-heading">
                Table Quality
              </div>
        <ReactECharts option={option} />
        </div>
      )}
    </React.Fragment>
  );
};
export default TableQualityGraph;
